import { useContext, useEffect, useState } from "react";
import Footer from "../../components/footer/footer";
import Navbar from "../../components/navbar/navbar";
import {
  query,
  onSnapshot,
  addDoc,
  doc,
  getDoc,
  getDocs,
  collection,
  startAfter,
  limit,
  orderBy,
} from "@firebase/firestore";
import { db } from "../../firebase";
import "../index.scss";
import "./singleCharacter.scss";
import Datatable from "../../components/datatable/datatable";
import {
  characterRows,
  lightConeRows,
  relic,
  calculateRelic,
  property,
} from "../../components/utils";
import { LanguageContext } from "../../App";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router-dom";
import { BreakfastDining, ThumbUpAlt } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import HorizontalDisplayAds from "../../components/ads/horizontalDisplayAds";

function loadLightconeImage(lightconeId) {
  return require(`../../components/image/lightcone/${lightconeId}.webp`);
}

function loadRelicImage(relicId) {
  return require(`../../components/image/relic/${relicId}.webp`);
}

const SingleCharacterRankingV2 = () => {
  const params = useParams();
  const [selectedId, setSelectedId] = useState("");
  const navigate = useNavigate();
  const [highlightedClass, setHighlightedClass] = useState("");

  const [lastRelic, setLastRelic] = useState("");
  const [cacheRelicList, setCacheRelicList] = useState([]);
  const [fullRelicList, setFullRelicList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);

  async function getTopCharacters(nextPage) {
    var relicQuery = query(
      collection(db, "character/id/" + selectedId.id.split("_")[0]),
      orderBy("total_score", "desc"),
      limit(10)
    );

    if (nextPage === true) {
      relicQuery = query(
        collection(db, "character/id/" + selectedId.id.split("_")[0]),
        orderBy("total_score", "desc"),
        startAfter(lastRelic),
        limit(10)
      );
    }

      var currentCount = 0;

    if (nextPage === true) {
      var currentPage = page;
      currentPage = currentPage + 1;

      setPage(currentPage);

      if (
        (currentPage + 1) * 10 > fullRelicList.length &&
        fullRelicList.length < totalCount
      ) {
      const documentSnapshots = await getDocs(relicQuery);
      var relics = [];
      documentSnapshots.forEach((doc) => {
        currentCount++;
        var currentData = doc.data();
        var region = "";
        switch (currentData.u.substring(0, 1)) {
          case "0":
            region = "miHoYo Internal";
            break;
          case "5":
            region = "CN-Alternative";
            break;
          case "2":
          case "1":
            region = "CN";
            break;
          case "6":
            region = "NA";
            break;
          case "7":
            region = "EU";
            break;
          case "8":
            region = "Asia";
            break;
          case "9":
            region = "THM";
            break;
          default:
            break;
        }

        currentData.m = currentData.c;
        if (Number(currentData.m) > 10) {
          currentData.m = 0;
        }

        for (let j = 0; j < currentData.p.length; j++) {

          switch (currentData.p[j].n) {
            case "Base HP":
            case "H":
              currentData.HP =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "Base ATK":
            case "A":
              currentData.Attack =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "Base DEF":
            case "D":
              currentData.Defend =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "S":
              currentData.Speed =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "EH":
              currentData.EffectHitRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.EffectHitRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EffectHitRate += currentData.p[j].a;
              }
              break;
            case "EG":
              currentData.EnergyRegenerationRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.EnergyRegenerationRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EnergyRegenerationRate += currentData.p[j].a;
              }
              break;
            case "O":
              currentData.OutgoingHealingBoost = 0;
              if (currentData.p[j].b !== null) {
                currentData.OutgoingHealingBoost += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.OutgoingHealingBoost += currentData.p[j].a;
              }
              break;
            case "BE":
              currentData.BreakEffect = 0;
              if (currentData.p[j].b !== null) {
                currentData.BreakEffect += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.BreakEffect += currentData.p[j].a;
              }
              break;
            case "CR":
              currentData.CriticalRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.CriticalRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.CriticalRate += currentData.p[j].a;
              }
              break;
            case "CD":
              currentData.CriticalDamage = 0;
              if (currentData.p[j].b !== null) {
                currentData.CriticalDamage += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.CriticalDamage += currentData.p[j].a;
              }
              break;
            case "ER":
              currentData.EffectResistance = 0;
              if (currentData.p[j].b !== null) {
                currentData.EffectResistance += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EffectResistance += currentData.p[j].a;
              }
              break;
            case "DBF":
            case "DBI":
            case "DBL":
            case "DBM":
            case "DBP":
            case "DBQ":
            case "DBW":
              {
                currentData.ElementalDamage = 0;
                switch (selectedId.element) {
                  case "Quantum":
                    if (currentData.p[j].n !== "DBQ") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Wind":
                    if (currentData.p[j].n !== "DBW") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Lightning":
                    if (currentData.p[j].n !== "DBL") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Imaginary":
                    if (currentData.p[j].n !== "DBM") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Physical":
                    if (currentData.p[j].n !== "DBP") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Fire":
                    if (currentData.p[j].n !== "DBF") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Ice":
                    if (currentData.p[j].n !== "DBI") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            default:
              break;
          }
        }

        currentData.HP = Math.floor(currentData.HP).toFixed(0);
        currentData.Attack = Math.floor(currentData.Attack).toFixed(0);
        currentData.Defend = Math.floor(currentData.Defend).toFixed(0);
        currentData.Speed = Math.floor(currentData.Speed).toFixed(0);

        if (typeof currentData.ElementalDamage === "undefined") {
          currentData.ElementalDamage = 0;
        }
        currentData.ElementalDamage = (
          Math.floor(currentData.ElementalDamage * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.BreakEffect === "undefined") {
          currentData.BreakEffect = 0;
        }
        currentData.BreakEffect = (
          Math.floor(currentData.BreakEffect * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.OutgoingHealingBoost === "undefined") {
          currentData.OutgoingHealingBoost = 0;
        }
        currentData.OutgoingHealingBoost = (
          Math.floor(currentData.OutgoingHealingBoost * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EnergyRegenerationRate === "undefined") {
          currentData.EnergyRegenerationRate = 0;
        }
        currentData.EnergyRegenerationRate = (
          Math.floor(currentData.EnergyRegenerationRate * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EffectHitRate === "undefined") {
          currentData.EffectHitRate = 0;
        }
        currentData.EffectHitRate = (
          Math.floor(currentData.EffectHitRate * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EffectResistance === "undefined") {
          currentData.EffectResistance = 0;
        }
        currentData.EffectResistance = (
          Math.floor(currentData.EffectResistance * 1000) / 10
        ).toFixed(1);

        currentData.CriticalRate = (
          Math.floor(currentData.CriticalRate * 1000) / 10
        ).toFixed(1);
        currentData.CriticalDamage = (
          Math.floor(currentData.CriticalDamage * 1000) / 10
        ).toFixed(1);

        for (let j = 0; j < currentData.rs.length; j++) {
          if (typeof currentData.rs[j].n === "undefined") continue;

          var setNumber = currentData.rs[j].d;
          currentData.rs[j] = relic.filter(
            (id) =>
              id.code === currentData.rs[j].n || id.name === currentData.rs[j].n
          )[0];
          
          currentData.rs[j].d = setNumber;
          currentData.rs[j].image = loadRelicImage(currentData.rs[j].id);
        }

        currentData.LightCone = currentData.lc;
        currentData.LightCone.image = loadLightconeImage(currentData.LightCone.i);
        var currentNo = currentPage * 10 + currentCount;
            setFullRelicList((oldArray) => [
            ...oldArray,
            {
              id: currentData.u,
              no: currentNo,
              uid: currentData.u,
              name: currentData.n,
              eidolon: currentData.r,
              formula: currentData.total_score,
              RelicSet: currentData.rs,
              LightCone: currentData.lc,
              CriticalDamage: currentData.CriticalDamage,
              CriticalRate: currentData.CriticalRate,
              level: currentData.l,
              HP: currentData.HP,
              Attack: currentData.Attack,
              Defend: currentData.Defend,
              Speed: currentData.Speed,
              OutgoingHealingBoost: currentData.OutgoingHealingBoost,
              EnergyRegenerationRate: currentData.EnergyRegenerationRate,
              EffectHitRate: currentData.EffectHitRate,
              BreakEffect: currentData.BreakEffect,
              EffectResistance: currentData.EffectResistance,
              ElementalDamage: currentData.ElementalDamage,
              updated_at: currentData.d,
            },
          ]);
        setLastRelic(doc);
      });
      }
    } else {
      const documentSnapshots = await getDocs(relicQuery);
      var relics = [];
      documentSnapshots.forEach((doc) => {
        currentCount++;
        var currentData = doc.data();
        var region = "";
        switch (currentData.u.substring(0, 1)) {
          case "0":
            region = "miHoYo Internal";
            break;
          case "5":
            region = "CN-Alternative";
            break;
          case "2":
          case "1":
            region = "CN";
            break;
          case "6":
            region = "NA";
            break;
          case "7":
            region = "EU";
            break;
          case "8":
            region = "Asia";
            break;
          case "9":
            region = "THM";
            break;
          default:
            break;
        }

        currentData.m = currentData.c;
        if (Number(currentData.m) > 10) {
          currentData.m = 0;
        }

        for (let j = 0; j < currentData.p.length; j++) {

          switch (currentData.p[j].n) {
            case "Base HP":
            case "H":
              currentData.HP =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "Base ATK":
            case "A":
              currentData.Attack =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "Base DEF":
            case "D":
              currentData.Defend =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "S":
              currentData.Speed =
                Number(currentData.p[j].a) + Number(currentData.p[j].b);
              break;
            case "EH":
              currentData.EffectHitRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.EffectHitRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EffectHitRate += currentData.p[j].a;
              }
              break;
            case "EG":
              currentData.EnergyRegenerationRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.EnergyRegenerationRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EnergyRegenerationRate += currentData.p[j].a;
              }
              break;
            case "O":
              currentData.OutgoingHealingBoost = 0;
              if (currentData.p[j].b !== null) {
                currentData.OutgoingHealingBoost += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.OutgoingHealingBoost += currentData.p[j].a;
              }
              break;
            case "BE":
              currentData.BreakEffect = 0;
              if (currentData.p[j].b !== null) {
                currentData.BreakEffect += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.BreakEffect += currentData.p[j].a;
              }
              break;
            case "CR":
              currentData.CriticalRate = 0;
              if (currentData.p[j].b !== null) {
                currentData.CriticalRate += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.CriticalRate += currentData.p[j].a;
              }
              break;
            case "CD":
              currentData.CriticalDamage = 0;
              if (currentData.p[j].b !== null) {
                currentData.CriticalDamage += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.CriticalDamage += currentData.p[j].a;
              }
              break;
            case "ER":
              currentData.EffectResistance = 0;
              if (currentData.p[j].b !== null) {
                currentData.EffectResistance += currentData.p[j].b;
              }

              if (currentData.p[j].a !== null) {
                currentData.EffectResistance += currentData.p[j].a;
              }
              break;
            case "DBF":
            case "DBI":
            case "DBL":
            case "DBM":
            case "DBP":
            case "DBQ":
            case "DBW":
              {
                currentData.ElementalDamage = 0;
                switch (selectedId.element) {
                  case "Quantum":
                    if (currentData.p[j].n !== "DBQ") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Wind":
                    if (currentData.p[j].n !== "DBW") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Lightning":
                    if (currentData.p[j].n !== "DBL") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Imaginary":
                    if (currentData.p[j].n !== "DBM") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Physical":
                    if (currentData.p[j].n !== "DBP") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Fire":
                    if (currentData.p[j].n !== "DBF") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  case "Ice":
                    if (currentData.p[j].n !== "DBI") continue;

                    if (currentData.p[j].b !== null) {
                      currentData.ElementalDamage += currentData.p[j].b;
                    }

                    if (currentData.p[j].a !== null) {
                      currentData.ElementalDamage += currentData.p[j].a;
                    }
                    break;
                  default:
                    break;
                }
              }
              break;
            default:
              break;
          }
        }

        currentData.HP = Math.floor(currentData.HP).toFixed(0);
        currentData.Attack = Math.floor(currentData.Attack).toFixed(0);
        currentData.Defend = Math.floor(currentData.Defend).toFixed(0);
        currentData.Speed = Math.floor(currentData.Speed).toFixed(0);

        if (typeof currentData.ElementalDamage === "undefined") {
          currentData.ElementalDamage = 0;
        }
        currentData.ElementalDamage = (
          Math.floor(currentData.ElementalDamage * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.BreakEffect === "undefined") {
          currentData.BreakEffect = 0;
        }
        currentData.BreakEffect = (
          Math.floor(currentData.BreakEffect * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.OutgoingHealingBoost === "undefined") {
          currentData.OutgoingHealingBoost = 0;
        }
        currentData.OutgoingHealingBoost = (
          Math.floor(currentData.OutgoingHealingBoost * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EnergyRegenerationRate === "undefined") {
          currentData.EnergyRegenerationRate = 0;
        }
        currentData.EnergyRegenerationRate = (
          Math.floor(currentData.EnergyRegenerationRate * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EffectHitRate === "undefined") {
          currentData.EffectHitRate = 0;
        }
        currentData.EffectHitRate = (
          Math.floor(currentData.EffectHitRate * 1000) / 10
        ).toFixed(1);

        if (typeof currentData.EffectResistance === "undefined") {
          currentData.EffectResistance = 0;
        }
        currentData.EffectResistance = (
          Math.floor(currentData.EffectResistance * 1000) / 10
        ).toFixed(1);

        currentData.CriticalRate = (
          Math.floor(currentData.CriticalRate * 1000) / 10
        ).toFixed(1);
        currentData.CriticalDamage = (
          Math.floor(currentData.CriticalDamage * 1000) / 10
        ).toFixed(1);

        for (let j = 0; j < currentData.rs.length; j++) {
          if (typeof currentData.rs[j].n === "undefined") continue;

          var setNumber = currentData.rs[j].d;
          currentData.rs[j] = relic.filter(
            (id) =>
              id.code === currentData.rs[j].n || id.name === currentData.rs[j].n
          )[0];
          
          currentData.rs[j].d = setNumber;
          currentData.rs[j].image = loadRelicImage(currentData.rs[j].id);
        }

        currentData.LightCone = currentData.lc;
        currentData.LightCone.image = loadLightconeImage(currentData.LightCone.i);

        relics.push({
          id: currentData.u,
          no: currentCount,
          uid: currentData.u,
          name: currentData.n,
          eidolon: currentData.r,
          formula: currentData.total_score,
          RelicSet: currentData.rs,
          LightCone: currentData.lc,
          CriticalDamage: currentData.CriticalDamage,
          CriticalRate: currentData.CriticalRate,
          level: currentData.l,
          HP: currentData.HP,
          Attack: currentData.Attack,
          Defend: currentData.Defend,
          Speed: currentData.Speed,
          OutgoingHealingBoost: currentData.OutgoingHealingBoost,
          EnergyRegenerationRate: currentData.EnergyRegenerationRate,
          EffectHitRate: currentData.EffectHitRate,
          BreakEffect: currentData.BreakEffect,
          EffectResistance: currentData.EffectResistance,
          ElementalDamage: currentData.ElementalDamage,
          updated_at: currentData.d,
        });
        setLastRelic(doc);
      });

      setPage(0);
      setFullRelicList(relics);
    }
  }

  function highlightClass(className) {
    setHighlightedClass(className);
    var elms = document.getElementsByClassName("property-" + className);
    var n = elms.length;

    for (var i = 0; i < n; i++) {
      elms[i].style.cursor = "pointer";
      elms[i].style.transition = "all 0.2s ease-in-out";
      elms[i].style["-webkit-filter"] =
        "drop-shadow(0px 0px 5px red) drop-shadow(0px 0px 10px red) drop-shadow(0px 0px 15px red)";
    }
  }

  function dehighlightClass(className) {
    var elms = document.getElementsByClassName("property-" + className);
    var n = elms.length;

    for (var i = 0; i < n; i++) {
      elms[i].style["-webkit-filter"] = "";
    }
  }

  window.addEventListener(
    "scroll",
    function () {
      if (highlightedClass !== "") {
        dehighlightClass(highlightedClass);
        setHighlightedClass("");
      }
    },
    false
  );

  // Initialize Character with Name
  var count = 0;

  useEffect(() => {
    var character = characterRows.filter(
      (id) => id.name === params.characterName
    );
    if (character.length === 0) {
      navigate("/");
    } else {
      setSelectedId(character[0]);
      if (count == 0) {
        count++;
        //console.log(count);
        //handleSelectedCharacter(character[0].id);
      }
    }
  }, [params]);

  const languageContext = useContext(LanguageContext);
  const language = {
    ascension_materials: {
      "zh-cn": "总晋阶材料",
      "zh-tw": "總晋阶材料",
      "en-us": "Total Ascension Materials",
    },
    trace_materials: {
      "zh-cn": "总行迹材料",
      "zh-tw": "總行迹材料",
      "en-us": "Total Trace Materials",
    },
    score: {
      "zh-cn": "分数",
      "zh-tw": "分數",
      "en-us": "Score",
    },
    grade: {
      "zh-cn": "级别",
      "zh-tw": "級別",
      "en-us": "Grade",
    },
    custom_formula: {
      "en-us": "Custom Formula",
      "zh-cn": "自定义公式",
      "zh-tw": "自定義公式",
    },
    obtain: {
      "en-us": "Availability : ",
      "zh-cn": "获取方式 : ",
      "zh-tw": "獲取方式 : ",
    },
    based: {
      "en-us": "Mainly based on LV 1 of ",
      "zh-cn": "主要依据 LV 1 的 ",
      "zh-tw": "主要依據 LV 1 的",
    },
    complexity: {
      "en-us":
        "Due to the complexity, the formula doesn't include Eidolons and Lightcone.",
      "zh-cn": "基于复杂性，此公式并没计算星魂以及光锥。",
      "zh-tw": "基於復雜性，此公式並沒計算星魂以及光錐。",
    },
    searched_ranking: {
      "en-us": "Your Searched ",
      "zh-cn": "您查询的",
      "zh-tw": "您查詢的",
    },
    last_updated_at: {
      "en-us": "Updated At : ",
      "zh-cn": "更新于 : ",
      "zh-tw": "更新於 : ",
    },
    full_ranking: {
      "en-us": "'s Full Ranking",
      "zh-cn": "的完整排行榜",
      "zh-tw": "的完整排行榜",
    },
    top_lightcone: {
      "en-us": "Most Used Light Cone",
      "zh-cn": "最常用的光锥",
      "zh-tw": "最常用的光錐",
    },
    recommended_lightcone: {
      "en-us": "Light Cone Strength",
      "zh-cn": "光锥强度",
      "zh-tw": "光錐强度",
    },
    recommended_eidolons: {
      "en-us": "Eidolon Strength",
      "zh-cn": "星魂强度",
      "zh-tw": "星魂強度",
    },
    eidolon: {
      "en-us": "Eidolon",
      "zh-cn": "星魂",
      "zh-tw": "星魂",
    },
    development_guide: {
      "en-us": "Build Guide",
      "zh-cn": "养成攻略",
      "zh-tw": "養成攻略",
    },
    recommended_skill: {
      "en-us": "Skill",
      "zh-cn": "技能",
      "zh-tw": "技能",
    },
    recommended_traces: {
      "en-us": "Main Traces",
      "zh-cn": "主要行迹",
      "zh-tw": "主要行跡",
    },
    recommended_traces_priority: {
      "en-us": "Other Traces Priority",
      "zh-cn": "其他行迹优先度",
      "zh-tw": "其他行跡優先度",
    },
    recommended_main_stat: {
      "en-us": "Main Stat",
      "zh-cn": "主词条",
      "zh-tw": "主詞條",
    },
    recommended_sub_stat: {
      "en-us": "Sub Stat Priority",
      "zh-cn": "副词条优先度",
      "zh-tw": "副詞條優先度",
    },
    target_stats: {
      "en-us": "Target Stats",
      "zh-cn": "目标面板",
      "zh-tw": "目標面板",
    },
    recommended_cavern: {
      "en-us": "Cavern Relics",
      "zh-cn": "隧洞遗器",
      "zh-tw": "隧洞遺器",
    },
    recommended_planar: {
      "en-us": "Planar Ornaments",
      "zh-cn": "位面饰品",
      "zh-tw": "位面飾品",
    },
    top_cavern: {
      "en-us": "Most Used Cavern Relics",
      "zh-cn": "最常用的隧洞遗器",
      "zh-tw": "最常用的隧洞遺器",
    },
    leaderboard: {
      "en-us": "Leaderboard",
      "zh-cn": "排行榜",
      "zh-tw": "排行榜",
    },
    top_planar: {
      "en-us": "Most Used Planar Ornaments",
      "zh-cn": "最常用的位面饰品",
      "zh-tw": "最常用的位面飾品",
    },
    set: {
      "en-us": " Set",
      "zh-cn": " 件套",
      "zh-tw": " 件套",
    },
    close: {
      "en-us": "Close",
      "zh-cn": "关闭",
      "zh-tw": "關閉",
    },
    basic_attack: {
      "en-us": "Basic ATK",
      "zh-cn": "普通攻击",
      "zh-tw": "普通攻擊",
    },
    ultimate: {
      "en-us": "Ultimate",
      "zh-cn": "终结技",
      "zh-tw": "終結技",
    },
    talent: {
      "en-us": "Talent",
      "zh-cn": "天赋",
      "zh-tw": "天賦",
    },
    skill: {
      "en-us": "Skill",
      "zh-cn": "战技",
      "zh-tw": "戰技",
    },
    level: {
      "en-us": "Level",
      "zh-cn": "等级",
      "zh-tw": "等級",
    },
    team_comp: {
      "en-us": "Team Composition",
      "zh-cn": "配队思路",
      "zh-tw": "配隊思路",
    },
    type: {
      "en-us": "Type",
      "zh-cn": "种类",
      "zh-tw": "種類",
    },
    obtain_tooltip: {
      "en-us": "Obtain",
      "zh-cn": "获得",
      "zh-tw": "獲得",
    },
    rarity_tooltip: {
      "en-us": "Rarity",
      "zh-cn": "稀有度",
      "zh-tw": "稀有度",
    },
  };

  const [rankingRows, setRankingRows] = useState([]);
  const [secondRankingRows, setSecondRankingRows] = useState([]);
  const [processedRankingRows, setProcessedRankingRows] = useState([]);
  const [cacheRankingRows, setCacheRankingRows] = useState([]);
  const [randomSeedRanking, setRandomSeedRanking] = useState(0);
  const [modifiedCharacterRows, setModifiedCharacterRows] = useState([]);
  const [selectedCharacters, setSelectedCharacters] = useState(
    modifiedCharacterRows
  );
  const [lightCones, setLightCones] = useState([]);
  const [cavernRelics, setCavernRelics] = useState([]);
  const [planarRelics, setPlanarRelics] = useState([]);
  const [summaryCount, setSummaryCount] = useState(100);
  const [popupUid, setPopupUid] = useState("");
  const [popupProfile, setPopupProfile] = useState("");

  const [summaryData, setSummaryData] = useState({
    id: "0",
    last_report: new Date(),
  });

  useEffect(() => {
    async function initializeSummary() {
      if (typeof selectedId.id === "undefined") return;

      const reportDateRef = doc(db, "leaderboard", selectedId.id);
      const reportDateDocSnap = await getDoc(reportDateRef);

      if (reportDateDocSnap.exists()) {
        var reportDateData = reportDateDocSnap.data();
        setTotalCount(reportDateData.count);
        setSummaryCount(reportDateData.count);

        var lightcones = Object.entries(reportDateData.lc).sort((a, b) => b[1] - a[1]).slice(0, 5);
        var finalLightcones = [];
        for (let index = 0; index < lightcones.length; index++) {
          if(lightcones[index].length !== 2)
            continue;

          const lightconeId = lightcones[index][0];
          const count = lightcones[index][1];

          if (lightconeId === "") continue;

          var tempLightcone = lightConeRows.filter(
            (id) => id.id === lightconeId
          )[0];
          tempLightcone.count = count;
          tempLightcone.percentage = (
            (tempLightcone.count / reportDateData.count) *
            100
          ).toFixed(1);

          tempLightcone.image = loadLightconeImage(lightconeId);
          finalLightcones.push(tempLightcone);
        }
        setLightCones(finalLightcones);

        var cavernRelics = [];
        var planarRelics = [];
        
        var relics = Object.entries(reportDateData.rs).sort((a, b) => b[1] - a[1]);
        for (let index = 0; index < relics.length; index++) {
          if(relics[index].length !== 2 ||
            relic.filter((id) => id.code === String(relics[index][0]).split("_")[0]).length === 0
          )
            continue;

          var code = String(relics[index][0]).split("_")[0];
          var set = String(relics[index][0]).split("_")[0];
          var tempRelic = JSON.parse(
                      JSON.stringify(
                        relic.filter((id) => id.code === code)[0]
                      )
          );
          
          tempRelic.count = relics[index][1];
          tempRelic.percentage = (
            (relics[index][1] / reportDateData.count) *
            100
          ).toFixed(1);
          tempRelic.d = String(relics[index][0]).split("_")[1];
          tempRelic.image = loadRelicImage(tempRelic.id);

          if (tempRelic.type === "Cavern Relics") {
            cavernRelics.push(tempRelic);
          } else {
            planarRelics.push(tempRelic);
          }
        }

        cavernRelics = cavernRelics.sort((a, b) =>
          a.count < b.count ? 1 : -1
        );
        setCavernRelics(cavernRelics);

        planarRelics = planarRelics.sort((a, b) =>
          a.count < b.count ? 1 : -1
        );
        setPlanarRelics(planarRelics);
        setSummaryData(reportDateData);
      }
    }
    initializeSummary();

    if (typeof selectedId.id !== "undefined") {
      getTopCharacters();
    }


  }, [selectedId]);


  useEffect(() => {
    async function popUp() {
      if (popupUid === "") {
        return;
      }

      const userRef = doc(db, "character/id/" + selectedId.id, popupUid);
      const userDocSnap = await getDoc(userRef);

      if (userDocSnap.exists()) {
        var characterData = userDocSnap.data();
        characterData = await calculateRelic(
          characterData,
          languageContext.language,
          selectedId
        );
        setPopupProfile(characterData);
      }
    }
    popUp();
  }, [popupUid]);

  useEffect(() => {
    function processModifiedCharacterRows() {
      var modifiedRows = [];
      for (let i = 0; i < characterRows.length; i++) {
        switch (characterRows[i].id) {
          case "8001":
            var currentRow = characterRows[i];
            currentRow.id = "8001,8002";
            modifiedRows.push(currentRow);
            break;
          case "8002":
            break;
          case "8003":
            var currentRow = characterRows[i];
            currentRow.id = "8003,8004";
            modifiedRows.push(currentRow);
            break;
          case "8004":
            break;
          case "8005":
            var currentRow = characterRows[i];
            currentRow.id = "8005,8006";
            modifiedRows.push(currentRow);
            break;
          case "8006":
            break;
          default:
            modifiedRows.push(characterRows[i]);
        }
      }
      setModifiedCharacterRows(modifiedRows);
    }
    processModifiedCharacterRows();
  }, [characterRows]);

  useEffect(() => {
    setSelectedCharacters(modifiedCharacterRows);
  }, [modifiedCharacterRows]);

  function handleSelectedCharacter(id) {
    try {
      var currentCharacter = {};
      for (let i = 0; i < modifiedCharacterRows.length; i++) {
        if (String(modifiedCharacterRows[i].id) === String(id)) {
          currentCharacter = modifiedCharacterRows[i];
          setSelectedId(modifiedCharacterRows[i]);
          break;
        }
      }

      if (String(id).split(",").length === 1) {
        var rankingRows = [];
        const userDocsCollection = collection(
          db,
          "character-two/id/" + String(id)
        );
        const userDocsQuery = query(userDocsCollection, orderBy("u"), limit(8));
        const unsubscribe = onSnapshot(userDocsQuery, (snapshot) => {
          unsubscribe();

          if (snapshot.size === 0) {
            setRankingRows([]);
            setSecondRankingRows([]);
            setRandomSeedRanking(Math.random());
            return;
          }

          rankingRows = Object.assign([], rankingRows);
          snapshot.docChanges().forEach((change) => {
            //console.log(change.doc.data());

            if (change.type === "added") {
              rankingRows.push({
                temp_id: change.doc.id,
                character: change.doc.data().character,
                count: change.doc.data().count,
                sequence: change.doc.data().sequence,
                uid: change.doc.data().uid,
              });
            }

            if (change.type === "modified") {
              for (let i = 0; i < rankingRows.length; i++) {
                if (rankingRows[i].temp_id === change.doc.id) {
                  rankingRows[i] = {
                    temp_id: change.doc.id,
                    character: change.doc.data().character,
                    count: change.doc.data().count,
                    sequence: change.doc.data().sequence,
                    uid: change.doc.data().uid,
                  };
                }
              }
            }

            if (change.type === "removed") {
              rankingRows = rankingRows.filter(
                (item) => item.temp_id !== change.doc.id
              );
            }
          });

          setRankingRows(rankingRows);
          setRandomSeedRanking(Math.random());
        });
      } else {
        // Trail Blazer
        // Get 2 Genders

        var rankingRows = [];
        const firstUserDocsCollection = collection(
          db,
          "character-two/id/" + String(id).split(",")[0]
        );
        const firstUserDocsQuery = query(
          firstUserDocsCollection,
          orderBy("u"),
          limit(8)
        );
        const firstUnsubscribe = onSnapshot(firstUserDocsQuery, (snapshot) => {
          firstUnsubscribe();
          rankingRows = Object.assign([], rankingRows);
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              rankingRows.push({
                temp_id: change.doc.id,
                character: change.doc.data().character,
                count: change.doc.data().count,
                sequence: change.doc.data().sequence,
                uid: change.doc.data().uid,
              });
            }

            if (change.type === "modified") {
              for (let i = 0; i < rankingRows.length; i++) {
                if (rankingRows[i].temp_id === change.doc.id) {
                  rankingRows[i] = {
                    temp_id: change.doc.id,
                    character: change.doc.data().character,
                    count: change.doc.data().count,
                    sequence: change.doc.data().sequence,
                    uid: change.doc.data().uid,
                  };
                }
              }
            }

            if (change.type === "removed") {
              rankingRows = rankingRows.filter(
                (item) => item.temp_id !== change.doc.id
              );
            }
          });

          setRankingRows(rankingRows);
          setRandomSeedRanking(Math.random());
        });

        var secondRankingRows = [];
        const secondUserDocsCollection = collection(
          db,
          "character-two/id/" + String(id).split(",")[1]
        );
        const secondUserDocsQuery = query(
          secondUserDocsCollection,
          orderBy("u"),
          limit(8)
        );
        const secondUnsubscribe = onSnapshot(
          secondUserDocsQuery,
          (snapshot) => {
            secondUnsubscribe();

            secondRankingRows = Object.assign([], secondRankingRows);
            snapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                secondRankingRows.push({
                  temp_id: change.doc.id,
                  character: change.doc.data().character,
                  count: change.doc.data().count,
                  sequence: change.doc.data().sequence,
                  uid: change.doc.data().uid,
                });
              }

              if (change.type === "modified") {
                for (let i = 0; i < secondRankingRows.length; i++) {
                  if (secondRankingRows[i].temp_id === change.doc.id) {
                    secondRankingRows[i] = {
                      temp_id: change.doc.id,
                      character: change.doc.data().character,
                      count: change.doc.data().count,
                      sequence: change.doc.data().sequence,
                      uid: change.doc.data().uid,
                    };
                  }
                }
              }

              if (change.type === "removed") {
                secondRankingRows = secondRankingRows.filter(
                  (item) => item.temp_id !== change.doc.id
                );
              }
            });

            setSecondRankingRows(secondRankingRows);
            setRandomSeedRanking(Math.random());
          }
        );
      }
    } catch (e) {
      alert("We've encountered some errors.\nPlease try again later.");
      const ref = collection(db, "error");
      addDoc(ref, {
        code: "Single Character : Handle Selected Character",
        error: e.message,
        created_at: new Date(),
      });
    }
  }

  return (
    <div>
      {typeof selectedId !== "string" ? (
        <div className="singleCharacter">
          <Helmet>
            <title>
              {selectedId.translation[languageContext.language]} | HSR
              Statistics
            </title>
            <meta
              data-rh="true"
              property="description"
              content={
                selectedId.story[0][languageContext.language] +
                " " +
                selectedId.story[1][languageContext.language] +
                " ..."
              }
            />
            <meta
              data-rh="true"
              property="og:description"
              content={
                selectedId.story[0][languageContext.language] +
                " " +
                selectedId.story[1][languageContext.language] +
                " ..."
              }
            />
            <meta
              data-rh="true"
              property="twitter:description"
              content={
                selectedId.story[0][languageContext.language] +
                " " +
                selectedId.story[1][languageContext.language] +
                " ..."
              }
            />
            <meta
              data-rh="true"
              property="og:image"
              content={selectedId.background}
            />
            <meta
              data-rh="true"
              property="twitter:image"
              content={selectedId.background}
            />
          </Helmet>
          <Navbar />
          <div className="singleCharacterContainer starry-night">
            <div className="sub-container">
              <div className="sky">
                <div className="stars"></div>
                <div className="stars2"></div>
                <div className="stars3"></div>
              </div>
            </div>
            <div className="divider"></div>
            <div className="top">
              <h2 className="title">
                {selectedId.translation[languageContext.language]}
              </h2>
              <div className="property">
                <img
                  className="element"
                  alt={selectedId.element}
                  title={selectedId.element}
                  src={selectedId.elementIcon}
                />
                <img
                  className="path"
                  alt={selectedId.path}
                  title={selectedId.path}
                  src={selectedId.pathIcon}
                />
              </div>
              <img
                className="rarity"
                alt={selectedId.rarity_number}
                src={selectedId.rarity}
              />
              <div className="story">
                {selectedId.story.map((item, i) => {
                  return <h4 key={i}>{item[languageContext.language]}</h4>;
                })}
              </div>
              <img
                className="image"
                alt={selectedId.translation[languageContext.language]}
                src={`/characters/${selectedId.name}/${selectedId.name}_full.webp`}
              />
            </div>
            <HorizontalDisplayAds />
            <div className="secondTop">
              <div className="row">
                <h2>{language.top_cavern[languageContext.language]}</h2>
                {cavernRelics.length > 0 ? (
                  cavernRelics.slice(0, 5).map((item, i) => {
                    return (
                      <div key={"cavern-relic-" + i} className="innerRows">
                        <img
                          className="relicImage"
                          alt={item.translation_set[languageContext.language]}
                          src={item.image}
                        ></img>
                        <div className="barchart">
                          <h4 className="name">
                            {item.translation_set[languageContext.language]}
                            {" - "}
                            {item.d}
                            {language.set[languageContext.language]}
                          </h4>
                          <h4
                            className="count"
                            style={{
                              width: (item.count / summaryCount) * 100 + "%",
                              textOverflow: "clip",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.percentage} %
                          </h4>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <h4>NA</h4>
                )}
              </div>
              <div className="row">
                <h2>{language.top_planar[languageContext.language]}</h2>
                {planarRelics.length > 0 ? (
                  planarRelics.slice(0, 5).map((item, i) => {
                    return (
                      <div key={"planar-relics-" + i} className="innerRows">
                        <img
                          className="relicImage"
                          alt={item.translation_set[languageContext.language]}
                          src={item.image}
                        ></img>

                        <div className="barchart">
                          <h4 className="name">
                            {item.translation_set[languageContext.language]}
                            {" - "}
                            {item.d}
                            {language.set[languageContext.language]}
                          </h4>
                          <h4
                            className="count"
                            style={{
                              width: (item.count / summaryCount) * 100 + "%",
                              textOverflow: "clip",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.percentage} %
                          </h4>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <h4>NA</h4>
                )}
              </div>

              <div className="row">
                <h2>{language.top_lightcone[languageContext.language]}</h2>
                {lightCones.length > 0 ? (
                  lightCones.slice(0, 5).map((item, i) => {
                    return (
                      <div key={i} className="innerRows lightcone">
                        <img
                          className={"lightconeImage " + item.rarity_number}
                          alt={item.translation[languageContext.language]}
                          src={item.image}
                        ></img>
                        <div className="barchart">
                          <h4 className="name">
                            {item.translation[languageContext.language]}
                          </h4>
                          <h4
                            className="count"
                            style={{
                              width: (item.count / summaryCount) * 100 + "%",
                              textOverflow: "clip",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.percentage} %
                          </h4>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <h4>NA</h4>
                )}
              </div>
            </div>
            <HorizontalDisplayAds />
            <div className="middle">
              <div className="formula">
                <h2>{language.custom_formula[languageContext.language]}</h2>
                <h4>{language.complexity[languageContext.language]}</h4>
              </div>
            </div>
            <div className="bottom">
              {cacheRelicList.length > 0 ? (
                <div className="section">
                  <h2>
                    {language.searched_ranking[languageContext.language]}
                    {selectedId.translation[languageContext.language]}
                  </h2>

                  <Datatable
                    type="ranking"
                    className="datatable"
                    characterId={selectedId}
                    overrideDataRow={cacheRelicList}
                    setPopupUid={setPopupUid}
                  />
                </div>
              ) : (
                <p></p>
              )}

              <h2>
                {selectedId.translation[languageContext.language]}
                {language.full_ranking[languageContext.language]}
              </h2>
              <h3>
                {language.last_updated_at[languageContext.language]}{" "}
                {typeof summaryData.updated_dt !== "undefined"
                  ? new Date(
                      summaryData.updated_dt.seconds * 1000
                    ).toLocaleString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hourCycle: "h23",
                    })
                  : ""}
              </h3>
              <div className="sections relic-section">
                <Datatable
                  type="ranking"
                  className="datatable"
                  characterId={selectedId}
                  overrideDataRow={fullRelicList.slice(
                    page * 10,
                    (page + 1) * 10
                  )}
                  setPopupUid={setPopupUid}
                  sortModel={[
                    {
                      field: "ac",
                      sort: "desc",
                    },
                  ]}
                />
                <div className="dataTable-footer">
                  <h4
                    className="pagination"
                    onClick={() => {
                      var currentPage = page;
                      if (currentPage > 0) {
                        currentPage = currentPage - 1;
                        setPage(currentPage);
                      }
                    }}
                  >
                    {"<"}
                  </h4>

                  {(page + 1) * 10 > totalCount ? (
                    <h4></h4>
                  ) : totalCount > 10 ? (
                    <h4
                      className="pagination"
                      onClick={() => {
                        getTopCharacters(true);
                      }}
                    >
                      {">"}
                    </h4>
                  ) : (
                    <h4></h4>
                  )}
                  {(page + 1) * 10 > totalCount ? (
                    <h4>
                      {1 + page * 10}–{totalCount} of {totalCount}
                    </h4>
                  ) : totalCount > 10 ? (
                    <h4>
                      {1 + page * 10}–{(page + 1) * 10} of {totalCount}
                    </h4>
                  ) : (
                    <h4>1 – {totalCount}</h4>
                  )}
                </div>
              </div>
            </div>
            {popupProfile !== "" ? (
              <div className="popupContainer">
                <p
                  className="closeButton"
                  onClick={() => {
                    setPopupUid("");
                    setPopupProfile("");
                  }}
                >
                  x
                </p>

                <h2>
                  {popupProfile.n} - LV {popupProfile.l}
                </h2>
                {typeof popupProfile.rl !== "undefined" ? (
                  <div className="relics">
                    {popupProfile.rl.map((item, i) => {
                      return (
                        <div
                          key={item.i}
                          className={
                            item.r === 3
                              ? "relic three-star"
                              : item.r === 4
                              ? "relic four-star"
                              : item.r === 5
                              ? "relic five-star"
                              : "relic two-star"
                          }
                        >
                          <div className="relicTop">
                            {typeof item.set === "number" ? (
                              <div className="relic-set">
                                <div
                                  className="relic-set-desc"
                                  style={{ backgroundColor: item.set_color }}
                                >
                                  <h4>{item.set}</h4>
                                </div>
                              </div>
                            ) : (
                              <div></div>
                            )}
                            <img
                              className="relic-image"
                              style={{ cursor: "pointer" }}
                              title={item.name}
                              alt={item.i}
                              src={item.image}
                            />
                            <h4 className="level">+ {item.l}</h4>
                            <div
                              className={
                                "main-stat-container property-" + item.m.n
                              }
                              title={item.score_text}
                              onMouseOver={() => {
                                highlightClass(item.m.n);
                              }}
                              onMouseLeave={() => {
                                dehighlightClass(item.m.n);
                              }}
                            >
                              <div className="inner">
                                <img
                                  className="main-stat"
                                  alt={item.m.name}
                                  src={item.m.image}
                                ></img>
                                <h4 className="main-value">{item.m.v}</h4>
                              </div>
                              <h4 className="description">{item.m.name}</h4>
                            </div>
                            <div className="vertical_line"></div>
                          </div>

                          <div className="horizontal_line"></div>
                          <div className="relic-score">
                            <div className="score">
                              <h4 className="score-title">
                                {language.score[languageContext.language]}
                              </h4>
                              <h4 className="value">{item.score}</h4>
                            </div>
                            <div className="rank">
                              <h4 className="score-title">
                                {language.grade[languageContext.language]}
                              </h4>
                              <h4 className={"value rank-" + item.grade}>
                                {item.grade}
                              </h4>
                            </div>
                          </div>
                          <div className="horizontal_line"></div>
                          <div
                            className="subproperties"
                            title={item.score_text}
                          >
                            {item.s.map((subp, i) => {
                              return (
                                <div
                                  key={i}
                                  className={"subproperty property-" + subp.n}
                                  onMouseOver={() => {
                                    highlightClass(subp.n);
                                  }}
                                  onMouseLeave={() => {
                                    dehighlightClass(subp.n);
                                  }}
                                >
                                  <div className="inner">
                                    <img
                                      className={"sub-stat " + subp.n}
                                      alt={subp.n}
                                      src={subp.image}
                                    ></img>
                                    <h4
                                      className={
                                        "description score-" + subp.score
                                      }
                                    >
                                      {subp.name}
                                    </h4>
                                  </div>
                                  <div className="sub-value-container">
                                    {subp.e !== "undefined" && subp.e > 1 ? (
                                      <h4 className="enhancement">
                                        +{subp.e - 1}
                                      </h4>
                                    ) : (
                                      <h4 className="empty-enhancement">+0</h4>
                                    )}
                                    <h4
                                      className={
                                        "sub-value score-" + subp.score
                                      }
                                    >
                                      {subp.v}
                                    </h4>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div></div>
                )}
                <div className="closeBottomButton">
                  <button
                    className="button"
                    onClick={() => {
                      setPopupUid("");
                      setPopupProfile("");
                    }}
                  >
                    {language.close[languageContext.language]}
                  </button>
                </div>
                <br></br>
                <br></br>
              </div>
            ) : (
              <div></div>
            )}
          </div>
          <Footer />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

export default SingleCharacterRankingV2;
